module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/cinnamon@2x_da4b96.jpg";